module.exports = "/shifts/shift-acceptance/shiftAcceptanceDetailsComponent-ec8ed8.html";